<template>
    <Head title="Lounge Finder Search" />
    <div class="px-4 md:px-8">
        <LoungesSearch />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import LoungesSearch from '@/components/tools/lounges/lounges-search/lounges-search/index.vue';
</script>
